export default __webpack_public_path__ + "static/media/security-man.e258d0a5.svg";